
var lib_core = require("lib-core");

var FootprintViewerModel = function () {
    lib_core.Model.call(this);

    this.inspectorSubjects = this.set("inspectorSubjects", false);
};
lib_core.inherit(FootprintViewerModel, lib_core.Model);
FootprintViewerModel.$class = "FootprintViewerModel";

module.exports = FootprintViewerModel;

FootprintViewerModel.prototype.getInspectorSubjects = function() {
    return this.inspectorSubjects;
};

FootprintViewerModel.prototype.getInspectorSubelementSubject = function() {
    return null;
};
